import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Se existe uma posição de scroll salva para esta rota (voltando de um
    // imóvel para a listagem), deixa o useScrollRestore da página restaurar
    // a posição em vez de forçar o topo.
    const pendingRestoreKey = `scroll-${pathname.replace(/^\//, "")}`;
    if (sessionStorage.getItem(pendingRestoreKey)) {
      return;
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth", // Adiciona um efeito de rolagem suave
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;